import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=d63340c6&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d63340c6')) {
      api.createRecord('d63340c6', component.options)
    } else {
      api.reload('d63340c6', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=d63340c6&", function () {
      api.rerender('d63340c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jSnPnaVI85WZ/JS/comp/openstreetmap.vue"
export default component.exports